import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Checkbox from 'material-ui/Checkbox';

const styles = () => ({
  sectionContainerFinalLevel: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    padding: '12px',
  },

  item: {
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center',
  },

  text: {
    fontSize: '13px',
    color: '#181819',
    textOverflow: 'ellipsis',
    display: 'inline-block',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
  },

  label: {
    fontWeight: 'bold',
    fontSize: '8px',
    background: '#FFC62B',
    color: '#FFFFFF',
    padding: '1px 4px',
    marginLeft: '5px',
    whiteSpace: 'nowrap',
    borderRadius: '3px',
  },
});

/**
 * 階層構造のメニューの最下層のグリッドを表示するコンポーネント
 */
class FinalLevelGrid extends React.PureComponent {
  /**
   * 指定した列数に応じて、各アイテムの横幅のパーセンテージ文字列を返す。
   * 例: colCount = 4 の場合は "25%" を返す。
   *
   * @param {number} colCount 表示する列数（1 以上の整数を想定）
   * @returns {string} 幅の百分率（例: "25%"）
   */
  getItemWidthPercent(colCount) {
    const maxWidthPercent = 100;
    return `${maxWidthPercent / colCount}%`;
  }

  render() {
    const { classes, nodes, selectedItems, onToggle, colCount, contextData } = this.props;
    const width = this.getItemWidthPercent(colCount);

    return (
      <div className={classes.sectionContainerFinalLevel}>
        {nodes.map((n, idx) => {
          if (!n || n.id === undefined || n.id === null) return null;
          const isSelected = selectedItems.has(Number(n.id));
          return (
            <div key={idx} style={{ width, flexBasis: width, minWidth: 0, paddingTop: '10px' }}>
              <div className={classes.item}>
                <Checkbox
                  color="primary"
                  checked={isSelected}
                  style={{ width: '15px', height: '15px', marginRight: 5 }}
                  value={String(n.id)}
                  onChange={() => onToggle(n)}
                />
                <div className={classes.text} title={String(n.id)} onClick={() => onToggle(n)}>
                  {n.name || n.id}
                </div>
                {contextData && contextData.shouldShowLabel && contextData.shouldShowLabel(n) && (
                  <div className={classes.label}>{contextData.labelText || 'NEW'}</div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

FinalLevelGrid.propTypes = {
  classes: PropTypes.object.isRequired,
  nodes: PropTypes.array.isRequired,            // すべて葉
  selectedItems: PropTypes.object.isRequired,   // Immutable Set
  onToggle: PropTypes.func.isRequired,
  colCount: PropTypes.number.isRequired,
  contextData: PropTypes.object,
};

export default withStyles(styles)(FinalLevelGrid);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/SelectHierarchicalMenuDialog/common/FinalLevelGrid.jsx